
module.exports =  require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/wilddog/~/engine.io-client/index.js
 ** module id = 414
 ** module chunks = 1
 **/